import { render, staticRenderFns } from "./BTableCurrencies.vue?vue&type=template&id=2d89ef57&"
import script from "./BTableCurrencies.vue?vue&type=script&lang=js&"
export * from "./BTableCurrencies.vue?vue&type=script&lang=js&"
import style0 from "./BTableCurrencies.vue?vue&type=style&index=0&id=2d89ef57&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports